import React from 'react'

import {
  PageHeader,
  Identities,
  Cases,
  SvgIcon,
  NavLink
} from '../components'

export default class Search extends React.Component {
  render() {
    return (
      <section className='stage slds-grid slds-grid--vertical slds-nowrap'>
        <PageHeader name='Search Results:' />
        <div className='stage-main slds-grid slds-wrap slds-grow slds-scrollable--y' role="main">
          <div className='slds-grow slds-size--1-of-1 slds-medium-size--1-of-1 slds-large-size--12-of-12 slds-col-rule--right slds-p-top_x-large slds-p-around_medium'>
            <ClientSearchResults search={this.props.match.params.query} />
            <CaseSearchResults search={this.props.match.params.query} />
            <ContactSearchResults search={this.props.match.params.query} />
            <EmployerSearchResults search={this.props.match.params.query} />
          </div>
        </div>
      </section>
    )
  }
}

class ClientSearchResults extends React.PureComponent {
  state = {
    orderBy: 'first_name'
  }

  render() {
    return (
      <div className='slds-m-bottom_large'>
        <SvgIcon
          variant='utility'
          symbol='groups'
          className='slds-m-right_small'
        />
        <span className='u-font-size-large'>
          <NavLink to='/os/people/employees' >
            Clients
          </NavLink>
        </span>
        <Identities
          search={this.props.search}
          identityType='client'
          recordsPerPage={6}
          orderBy={this.state.orderBy}
          changeSort={orderBy => this.setState({ orderBy })}
        />
      </div>
    )
  }
}

class CaseSearchResults extends React.PureComponent {
  state = {
    orderBy: 'next_action_at'
  }

  render() {
    return (
      <div className='slds-m-bottom_large'>
        <SvgIcon
          variant='utility'
          symbol='overflow'
          className='slds-m-right_small'
        />
        <span className='u-font-size-large'>
          <NavLink to='/os/cases'>
            Cases
          </NavLink>
        </span>
        <Cases
          status=''
          productType=''
          requestType=''
          priority=''
          assignedTo=''
          createdBy=''
          startCreatedAt={null}
          endCreatedAt={null}
          startNextActionAt={null}
          endNextActionAt={null}
          idleForDate={null}
          search={this.props.search}
          reviewed=''
          resultsPerPage={5}
          orderBy={this.state.orderBy}
          changeSort={orderBy => this.setState({ orderBy })}
        />
      </div>
    )
  }
}

class ContactSearchResults extends React.PureComponent {
  state = {
    orderBy: 'first_name'
  }

  render() {
    return (
      <div className='slds-m-bottom_large'>
        <SvgIcon
          variant='utility'
          symbol='groups'
          className='slds-m-right_small'
        />
        <span className='u-font-size-large'>
          <NavLink to='/os/people/contacts'>
            Contacts
          </NavLink>
        </span>
        <Identities
          search={this.props.search}
          identityType='contact'
          recordsPerPage={5}
          orderBy={this.state.orderBy}
          changeSort={orderBy => this.setState({ orderBy })}
        />
      </div>
    )
  }
}

class EmployerSearchResults extends React.PureComponent {
  state = {
    orderBy: 'first_name'
  }

  render() {
    return (
      <div className='slds-m-bottom_large'>
        <SvgIcon
          variant='utility'
          symbol='groups'
          className='slds-m-right_small'
        />
        <span className='u-font-size-large'>
          <NavLink to='/os/people/employers'>
            Employers
          </NavLink>
        </span>
        <Identities
          search={this.props.search}
          identityType='employer'
          recordsPerPage={5}
          orderBy={this.state.orderBy}
          changeSort={orderBy => this.setState({ orderBy })}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Search.js